<div class="menu-container" [class.menu-open]="!menu.menuHidden" [attr.inert]="menu.menuHidden ? 'true' : null">
  <div class="menu-overlay" (click)="menu.closeMenu()"></div>
  <div [ngClass]="{ menu: true, hidden: menu.menuHidden }" role="dialog" aria-modal="true" aria-label="Mobile Navigation Menu">
    <nav #menuNav aria-label="Mobile Navigation" class="menuItems">
      <a routerLink="/" class="menuItem" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="menu.toggleMenu()"
        >Startseite</a
      >
      <a routerLink="/downloads" class="menuItem" routerLinkActive="active" (click)="menu.toggleMenu()">Downloads</a>
      <a routerLink="/kontakt" class="menuItem" routerLinkActive="active" (click)="menu.toggleMenu()">Kontakt</a>
    </nav>
  </div>
</div>
